import makeIndents from 'src/shared/directives/makeIndents';
import phone from 'src/shared/directives/phone';

export default {
  makeIndents,
  phone,
};
